module.exports = __webpack_public_path__ + "static/rajender-reddy-4282f58d8fc69d00690d1c125361da64.jpg";